{
  "id": "campaign-072",
  "name": "Mossy Fairway II",
  "seed": "campaign:72",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "._......,x..",
    "._.....,,,..",
    "._..........",
    "._..W..W....",
    "._W,...ooW..",
    "._..,sooFo..",
    ",_T,.s.ooT..",
    ",_...s......",
    ",_.T....T...",
    "._..T..T....",
    "._.......x..",
    "._....~.....",
    "._h...~~.h..",
    "._..........",
    "._~~........",
    "..~.........",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 3,
      "y": 16
    },
    {
      "kind": "squirrel",
      "x": 5,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 6,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 8
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 1
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 3
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 14
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 15
    },
    {
      "kind": "rare",
      "x": 1,
      "y": 10
    }
  ],
  "generatorVersion": 3,
  "level": 72,
  "biome": "golf",
  "par": {
    "reel": 7315,
    "push": 5686,
    "selfPropelled": 5088,
    "tractor": 4600,
    "zeroTurn": 3562,
    "fairway": 2523
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 0,
      "selfPropelled": 6,
      "tractor": 0,
      "zeroTurn": 21,
      "fairway": 15
    }
  }
}
